import React, { useState } from 'react';

import { connect } from 'react-redux';

import Helmet from 'wanderu-component-helmet';
import NotFound from 'wanderu-component-not-found';
import A from 'wanderu-component-react-router-link';
import TermsAndConditions from 'wanderu-component-terms-and-conditions';
import {
    Button,
    Modal,
    Lightbox,
    Layout,
    MarkdownContent,
    Typography,
} from 'wanderu-components';
import {
    userInfoSelectors,
    checkReferralCodeAction,
} from 'wanderu-ducks-account';
import { localize } from 'wanderu-i18n';

import chikuOnTheBeach from 'wanderu-assets/images/chiku-on-the-beach.png';
import referAFriend from 'wanderu-assets/images/refer-a-friend.svg';

import config from '../../config/baseApp.locales';
import SignUp from '../SignUp/BareSignUp';
import events from './ReferredSignUpEvents';

import styles from './ReferredSignUp.scss';

function ReferredSignUp(props) {
    const {
        hasValidReferralCode,
        isLoggedIn,
        match,
        t,
    } = props;

    const { referralCode } = match.params;
    const [signUpModalIsOpen, setSignUpModal] = useState(false);
    const [signedUp, setSignedUp] = useState(false);

    const onSignUp = () => {
        setSignUpModal(false);
        setSignedUp(true);
        events.fireReferredSignUpEvent({ referralCode });
    };

    if (!hasValidReferralCode) {
        return (
            <NotFound
                message={t('referral-lp-ref-invalid-code')}
                title={t('uh-oh')}
            />
        );
    }

    const title = t('referral-lp-ref-meta-title');
    const description = t('referral-lp-ref-meta-description');

    return (
        <>
            <Helmet
                description={description}
                supportedLocales={config.supportedLocales}
                title={title}
                noFollow
                noIndex
            />
            <Layout className={styles.container}>
                {signedUp
                    ? (
                        <>
                            <div className={styles.postSignUpContainer}>
                                <Typography className={styles.title} variant="h3">
                                    {t('referral-lp-ref-title2')}
                                </Typography>
                                <Typography
                                    className={styles.description}
                                    component="div"
                                >
                                    <MarkdownContent className={styles.markdownContainer}>
                                        {t('referral-lp-ref-description2')}
                                    </MarkdownContent>
                                </Typography>
                                <img
                                    alt="chiku on the beach"
                                    className={styles.bookImgMobile}
                                    src={chikuOnTheBeach}
                                />
                                <A
                                    className={styles.bookFirstTripLink}
                                    href="/"
                                >
                                    <Button className={styles.bookFirstTripButton}>

                                        {t('referral-lp-ref-button2')}
                                    </Button>
                                </A>
                            </div>
                            <div className={styles.imgContainer}>
                                <img
                                    alt="chiku on the beach"
                                    className={styles.bookImg}
                                    src={chikuOnTheBeach}
                                />
                            </div>
                        </>
                    )
                    : (
                        <>
                            <div className={styles.signUpContainer}>
                                <Typography className={styles.title} variant="h3">
                                    {t('referral-lp-ref-title')}
                                </Typography>
                                <Typography
                                    className={styles.description}
                                    component="div"
                                >
                                    <MarkdownContent className={styles.markdownContainer}>
                                        {t('referral-lp-ref-description')}
                                    </MarkdownContent>
                                    <TermsAndConditions
                                        href="/terms-and-conditions#Referral-Program"
                                        key="referral-page"
                                        linkText={t('referral-lp-terms-conditions')}
                                    />
                                </Typography>
                                <Button
                                    className={styles.signUpButton}
                                    onClick={() => setSignUpModal(true)}
                                >
                                    {t('referral-lp-ref-button')}
                                </Button>
                            </div>
                            <div className={styles.imgContainer}>
                                <img
                                    alt="refer a friend"
                                    className={styles.referImg}
                                    src={referAFriend}
                                />
                            </div>
                        </>
                    )}
                {signUpModalIsOpen && (
                    <Modal>
                        <Lightbox
                            innerClassName={styles.lightBox}
                            onHide={() => setSignUpModal(false)}
                        >
                            <SignUp
                                disabled={isLoggedIn}
                                onSuccess={onSignUp}
                                referralCode={referralCode}
                                subtitle={isLoggedIn
                                    ? (
                                        <Typography
                                            color="error"
                                            paragraph
                                        >
                                            {t('referral-lp-ref-existing-account')}
                                        </Typography>
                                    )
                                    : null}
                                suggestLogIn={false}
                                title={
                                    <Typography
                                        className={styles.signUpTitle}
                                        variant="h6"
                                    >
                                        Sign Up
                                    </Typography>
                                }
                            />
                        </Lightbox>
                    </Modal>
                )}
            </Layout>
        </>
    );
}

ReferredSignUp.serverFetchData = async (opts) => {
    const {
        dispatch,
        params,
    } = opts;
    const {
        referralCode,
    } = params;

    await dispatch(checkReferralCodeAction.check(referralCode));
};

function mapStateToProps(appState, ownProps) {
    const {
        match,
    } = ownProps;
    const {
        referralCode,
    } = match.params;

    return {
        isLoggedIn: userInfoSelectors.selectUserLoggedIn(appState),
        referralCode: userInfoSelectors.selectReferralCode(appState),
        hasValidReferralCode: checkReferralCodeAction.selectSuccess(appState, referralCode),
    };
}

const mapDispatchToProps = {
    checkReferralCode: checkReferralCodeAction,
};

export { ReferredSignUp };

const LocalizedReferredSignUp = localize(ReferredSignUp, config.namespace);
export default connect(mapStateToProps, mapDispatchToProps)(LocalizedReferredSignUp);
